import { selectRoomPeers } from "@src/selectors";
import { useSubscribe } from "@src/hooks/useSubscribe";
export const useNumberOfPeers = () => {
    const peers = useSubscribe(selectRoomPeers());
    return peers && Object.keys(peers).length;
};
